/**
 * Single entry for detecting the Electron shell. Do not import `electron` in UI components.
 */

export function isDesktop() {
  return (
    typeof window !== "undefined" &&
    window.doitifyDesktop != null &&
    typeof window.doitifyDesktop.invoke === "function"
  );
}

/**
 * @returns {import("../../types/electron.js").DoitifyDesktopBridge | null}
 */
export function getDesktopBridge() {
  if (typeof window === "undefined") return null;
  return window.doitifyDesktop ?? null;
}
